import React from 'react';
import {
  Box,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from '@mui/material';
import CertifiedStampPreview from './CertifiedStampPreview';
import {
  CERTIFIED_STAMP_FORM_SLOT_MIN_HEIGHT,
  CERTIFIED_STAMP_FORM_WIDTH,
  STAMP_LAYOUT_COMPACT,
  STAMP_LAYOUT_FULL,
  STAMP_PRINT_TOGGLE_NONE,
  normalizeStampLayout,
  stampPrintToggleValue,
} from './certifiedStampSpec';

/**
 * 원본대조필 인쇄 옵션 — 기본 | 간략 | 인쇄안함.
 * 미리보기 슬롯은 기본 양식 크기를 유지하고, 인쇄안함은 레거시처럼 블러.
 */
const CertifiedStampPrintPane = ({
  signOption,
  stampLayout,
  onChangeSignOption,
  onChangeStampLayout,
  control,
  signThumbnailUrl,
  emptyRecipient = false,
  emptySite = false,
  onChangeRecipient,
  onChangeSite,
  captionCompact,
  captionFull,
  header = null,
  children,
}) => {
  const printOff = signOption === 'NONE';
  const compact = normalizeStampLayout(stampLayout) === STAMP_LAYOUT_COMPACT;
  const toggleValue = stampPrintToggleValue(signOption, stampLayout);
  const caption = compact ? captionCompact : captionFull;

  const handleToggle = (_e, v) => {
    if (!v) return;
    if (v === STAMP_PRINT_TOGGLE_NONE) {
      onChangeSignOption('NONE');
      return;
    }
    onChangeSignOption('CERTIFIED_TRUE_COPY_AND_SIGN');
    onChangeStampLayout(v);
  };

  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'center', mb: 1, flexShrink: 0 }}>
        <ToggleButtonGroup
          color="primary"
          exclusive
          size="small"
          value={toggleValue}
          onChange={handleToggle}
        >
          <ToggleButton value={STAMP_LAYOUT_FULL}>기본</ToggleButton>
          <ToggleButton value={STAMP_LAYOUT_COMPACT}>간략</ToggleButton>
          <ToggleButton value={STAMP_PRINT_TOGGLE_NONE}>인쇄안함</ToggleButton>
        </ToggleButtonGroup>
      </Box>
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 1.5,
          py: 1,
          opacity: printOff ? 0.5 : 1,
          filter: printOff ? 'blur(2px)' : 'none',
          pointerEvents: printOff ? 'none' : 'auto',
        }}
      >
        {header}
        {caption ? (
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{
              textAlign: 'center',
              width: '100%',
              minHeight: 40,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {caption}
          </Typography>
        ) : null}
        <Box
          sx={{
            width: CERTIFIED_STAMP_FORM_WIDTH,
            maxWidth: '100%',
            minHeight: CERTIFIED_STAMP_FORM_SLOT_MIN_HEIGHT,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <CertifiedStampPreview
            control={control}
            signThumbnailUrl={signThumbnailUrl}
            emptyRecipient={emptyRecipient}
            emptySite={emptySite}
            onChangeRecipient={onChangeRecipient}
            onChangeSite={onChangeSite}
            compact={compact}
          />
        </Box>
        {children}
      </Box>
    </>
  );
};

export default CertifiedStampPrintPane;
